import { FC } from 'react';

import { SvgIconProps } from '@mui/material';

export const CloseIcon: FC<SvgIconProps> = (props) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.501803 -2.47955e-05C0.373598 -2.47955e-05 0.245393 0.0480518 0.147236 0.146209C-0.0490785 0.342524 -0.0490785 0.659029 0.147236 0.855343L9.14563 9.85374C9.34195 10.0501 9.65845 10.0501 9.85477 9.85374C10.0511 9.65743 10.0511 9.34092 9.85477 9.14461L0.85637 0.146209C0.758213 0.0480518 0.630008 -2.47955e-05 0.501803 -2.47955e-05Z"
      fill="#A3A7B0"
    />
    <path
      d="M9.50065 1.23978e-05C9.37245 1.23978e-05 9.24424 0.048089 9.14608 0.146247L0.147686 9.14464C-0.0466246 9.34096 -0.0466246 9.65746 0.147686 9.85378C0.344 10.0481 0.660507 10.0481 0.856821 9.85378L9.85522 0.855381C10.0515 0.659066 10.0515 0.342561 9.85522 0.146247C9.75706 0.048089 9.62886 1.23978e-05 9.50065 1.23978e-05Z"
      fill="#A3A7B0"
    />
  </svg>
);
